module.exports = __webpack_public_path__ + "img/timeline-14.946df547.svg";